import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function ListFilter($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M2 5h20" }],
		["path", { "d": "M6 12h12" }],
		["path", { "d": "M9 19h6" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiTGlzdEZpbHRlci5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNMiA1aDIwXCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNNiAxMmgxMlwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTkgMTloNlwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7c0RBRGxDLENBQUM7T0FFTyxRQUE0QztHQUFLLE1BQU0sSUFBSSxHQUFHLEVBQUUsU0FBUztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsVUFBVTtHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsU0FBUzs7O0tBQ3hJLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9